import React from 'react';
import cls from 'classnames';
import styles from './Container.module.scss';

function Container({children, className = '', ...other}) {
  return (
    <div className={cls(styles.container, className)} {...other}>
      {children}
    </div>
  );
}

export default Container;
